import { render, staticRenderFns } from "./NarrativeEdit.vue?vue&type=template&id=63abd569&"
import script from "./NarrativeEdit.vue?vue&type=script&lang=js&"
export * from "./NarrativeEdit.vue?vue&type=script&lang=js&"
import style0 from "./NarrativeEdit.vue?vue&type=style&index=0&id=63abd569&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports